import { render, staticRenderFns } from "./accountDetail.vue?vue&type=template&id=e4a4abe2&scoped=true&"
import script from "./accountDetail.vue?vue&type=script&lang=js&"
export * from "./accountDetail.vue?vue&type=script&lang=js&"
import style0 from "./accountDetail.vue?vue&type=style&index=0&id=e4a4abe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a4abe2",
  null
  
)

export default component.exports